import styled from "@emotion/styled";
import React from "react";
import { EmblaCarousel } from "../EmblaCarousel";
import {
  OverrideSlideProps,
  ResourceCard,
  ResourceCardProps,
} from "../ResourceCard";
import { snowdrop } from "../theme/ecologi-colors";
import { isImpactShop } from "../utils/is-impact-shop";
import { useIsTabletUp } from "../utils/use-media-breakpoints";

const Outer = styled.div`
  display: flex;
  flex-direction: column;
`;

export type ResourceRowProps = {
  data: ResourceCardProps[];
  overrideEndSlides?: OverrideSlideProps[];
  hasLightStyles?: boolean;
  isDotNavVisible?: boolean;
  slug?: string | string[];
};

export const ResourcesCarousel = ({
  data,
  overrideEndSlides,
  hasLightStyles,
  isDotNavVisible,
  slug,
}: ResourceRowProps) => {
  const slides = data.map((resource, index) => {
    const CardComponent = hasLightStyles ? ResourceCard.White : ResourceCard;

    return (
      <CardComponent
        key={index}
        title={resource.title}
        description={resource.description}
        link={resource.link}
        image={resource.image}
        label={resource.label}
        slug={slug}
      />
    );
  });

  const endSlides = overrideEndSlides?.map(({ component }, index) => {
    return <ResourceCard.Override key={index} component={component} />;
  });

  return (
    <Outer>
      {useIsTabletUp() ? (
        <EmblaCarousel.Multislide
          arrowNavigation
          buttonBgColor={hasLightStyles ? snowdrop : undefined}
          carouselWidth={1065}
          cardWidth={338}
          slides={[...slides, ...(endSlides ? endSlides : [])]}
          infiniteLoop
          isDotNavVisible={isDotNavVisible}
          slug={slug}
        />
      ) : (
        <EmblaCarousel
          arrowNavigation
          buttonBgColor={hasLightStyles ? snowdrop : undefined}
          carouselWidth={327}
          slides={slides}
          navigationSeparatorHeight={isImpactShop(slug) ? 40 : 64}
          isDotNavVisible={isDotNavVisible}
        />
      )}
    </Outer>
  );
};
